import MobileTitleBar                                                                 from "components/MobileTitleBar"
import Price                                                                          from "components/Price/Price"
import Badge                                                                          from "components/Product/Badge"
import ProductCard                                                                    from "components/Product/ProductCard"
import ProductFullscreen                                                              from "components/Product/ProductFullscreen"
import ProductImages                                                                  from "components/Product/ProductImages"
import ProductList                                                                    from "components/Product/ProductList"
import ProductPrice                                                                   from "components/Product/ProductPrice"
import ProductQuantityGroup                                                           from "components/Product/ProductQuantityGroup"
import ProductSearch                                                                  from "components/Product/ProductSearch"
import ProductSearchExtra                                                             from "components/Product/ProductSearchExtra"
import ProductPath                                                                    from "components/ProductPath"
import Variants                                                                       from "components/Variants/Variants"
import { Col, Row }                                                                   from "elemental-react16"
import _                                                                              from "lodash"
import PropTypes                                                                      from "prop-types"
import React, { Component, Fragment }                                                           from "react"
import Responsive                                                                     from "react-responsive"
import { Link }                                                                       from "react-router-dom"
import { Button, Card, Container, Icon, Input, Label, Message, Popup, Select, Table , Image} from "semantic-ui-react"
import shop                                                                           from "shop/shop"
import track                                                                          from "shop/track"
import categoryStore                                                                  from "stores/categoryStore"
import productStore                                                                   from "stores/productStore"
import "style/ProductPage.scss"
import cmsStore                                                                       from "stores/cmsStore"
import { ProductDownloads }                                                           from "components/ProductDownloads";
import ButtonLove                                                                     from "components/Button/ButtonLove";
import { SEOProduct }                                                                 from "../../../components/SEO";
import WordPressShopComponent                                                         from "../../../components/WordPressShopComponent/WordPressShopComponent";
import ProductReplacementHints                                                        from "../../../components/Product/ProductReplacementHints";
import CustomFields                                                                   from "components/CustomFields/CustomFields"
import Collapsible                                                                    from 'react-collapsible';

let lastProducts = null

const IconImage = ( { src, description } ) => <Popup content={description}
                                                     trigger={<img className="mr2 icon-product-attribute" width="42"
                                                                   src={src} alt=""/>}/>

export default class ProductPage extends Component {

  componentWillUnmount() {
    document.body.classList.remove( "no-scroll" )
  }

  constructor( props ) {
    const { match } = props
    super()
    this.state = {
      id: match.params.productId,
      product: {},
      fullscreenElement: null,
      variants: false
    }
  }

  loadProduct( id ) {
    if ( this.id === id ) return
    this.id = id
    productStore.get( id )
                .then( product => {
                  console.log( "ProductPage::product", product )
                  product.count = 1
                  let inCart = shop.cart.productsById.get( product.map_id )
                  if ( inCart ) product.count = Number( inCart.count )
                  shop.analytics.push( product.map_id )
                  track.viewDetails( { product } )
                  console.log( 'track pushed' );
                  lastProducts = shop.analytics.lastProducts( 4 )
                                     .filter( ( id ) => id !== product.map_id )
                  this.setState( { product: product, primaryImage: false } )

                  if ( !product.mainart ) return

                  productStore.partlist( product.mainart )
                              .then( variants => {
                                // let colors = variants.products.map( product => {
                                //   return {
                                //     color:  product.extras.Farbe,
                                //     map_id: product.map_id
                                //   }
                                // } )

                                let byAttribute = {}
                                variants.variants.varfields.forEach( varfield => {
                                  let categories = _.groupBy( variants.products, `extras.${varfield}` )
                                  var ordered = {};
                                  _( categories ).keys().sort().each( function ( key ) {
                                    ordered[ key ] = categories[ key ];
                                  } );
                                  byAttribute[ varfield ] = ordered

                                } )
                                this.setState( { variants, byAttribute } )
                              } )
                } )
                .catch( err => {
                  console.error( `Product not available ${id}` )
                  console.error( err )
                  this.setState( { error: true } )
                } )
  }

  add = ( { product } ) => {
    //if ( product.count === 0 ) return shop.cart.remove( product )
    let ok = shop.cart.add( product )
    if ( ok ) shop.toast( `${product.count * product.unit_multi} VE ${product.title} ${translate( "im Warenkorb" )}`, "info", false, "bottom" )

  }

  updateProduct = ( { product } ) => {
    this.setState( { product } )
  }

  componentWillReceiveProps( { match } ) {
    let { productId } = match.params
    this.loadProduct( productId )
  }

  showFullscreen = ( element ) => {
    this.setState( {
                     fullscreenElement: element
                   } )
  }

  setPrimaryImage = ( primaryImage ) => {
    this.setState( { primaryImage } )
  }

  componentDidMount() {
    this.loadProduct( this.state.id )
  }

  render() {
    let { fullscreenElement, product, byAttribute, primaryImage, error } = this.state

    if ( error ) return <div className={"vh-75 tc flex justify-center items-center"}>
      <div>
        <h3>404</h3>
        <div>Produkt nicht gefunden</div>
      </div>
    </div>

    if ( !product._type ) return null //  duck type check for ProductModel
    let img_srcs = product.img_srcs

    let category = product.cats[ 0 ] && product.cats[ 0 ] || {}
    let cat_id = category.cat_id

    let productImage
    if ( product.img_src ) {
      productImage = product.img_src_large
    }

    if ( primaryImage ) productImage = primaryImage

    // let categoryName = shop.categoryName(product.cats[0].cat_id)
    let path = shop.getCategoryPath( cat_id )

    path.push( {
                 title: product.title,
                 link: ""
               } )

    const veOptions = product.quantities.map( q => {
      return (
        {
          key: q.map_desc_id,
          text: `${q.des} (${q.multi})`,
          value: q.map_desc_id
        }
      )
    } )

    // const veOptions = [
    //   { key: 'all', text: 'All', value: 'all' },
    //   { key: 'articles', text: 'Articles', value: 'articles' },
    //   { key: 'products', text: 'Products', value: 'products' },
    // ]

    return (
      <div className="bg-white cssLindtGrey ProductPage">
        <SEOProduct product={product}/>
        <MobileTitleBar>
          <ProductPath path={path} title={product.title} product={product}/>
        </MobileTitleBar>
        <WordPressShopComponent key={`product-${product.map_id}`} slug={`product-${product.map_id}-top`}/>
        <Container className="relative  ">
          <ProductFullscreen
            change={this.showFullscreen}
            images={img_srcs}
            image={fullscreenElement}/>

          <Responsive minWidth={790}>
            <div className="db pv3 ">
              <ProductPath path={path} title={product.title} product={product}/>
            </div>
          </Responsive>

          {/*<Breadcrumbs path={path}/>*/}
          <section className="product product-single pb6-ns pb5">
            <Row>
              <Col sm="1" md="1/2" lg="7/12" className="relative">
                <div className="absolute right-2 pr3"><Badge product={product}/></div>
                <ProductImages
                  key={product.map_id}
                  product={product} images={img_srcs} image={productImage}
                  onClick={this.showFullscreen}
                  onClickSecondary={this.setPrimaryImage}/>
              </Col>
              <Col sm="1" md="1/2" lg="5/12">

                <TitleSection product={product}/>

                {/*{shop.session && <ActionSection product={product}*/}
                {/*onChange={this.updateProduct}*/}
                {/*onAdd={this.add}/>*/}
                {/*}*/}
                {shop.session && <div className="pt4 pb4 bb b--black-10 relative">
                  <div className="absolute right-0 top-0 pt3 ">
                    <table className="f5 fw5" style={{borderCollapse: "collapse"}}>
                      <tbody>
                        <tr>
                          <td className="tl" style={{padding: 0, paddingRight: 20}}>{translate( "Brutto EK* pro KE:" )}</td>
                          <td className="tr" style={{padding: 0}}>{product.extras.preisEK && product.extras.preisEK.value.value ? <span className="fw6">{Number(product.extras.preisEK.value.value).toFixed(3).replace(".", ",")} €</span> : <span className="f3 fw7">---</span>}</td>
                        </tr>
                        <tr>
                          <td className="tl" style={{padding: 0, paddingRight: 20}}>{translate( "UVP** pro KE:" )}</td>
                          <td className="tr" style={{padding: 0}}>{product.extras.preisUVP && product.extras.preisUVP.value.value ? <span className="fw6">{Number(product.extras.preisUVP.value.value).toFixed(2).replace(".", ",")} €</span> : <span className="f3 fw7">---</span>}</td>
                        </tr>
                        {/*<tr>
                          <td className="tl pr3">{translate( "Brutto EK* pro VE:" )}</td>
                          <td className="tr">{product.price ? <span className="fw6">{Number(product.price).toFixed(3).replace(".", ",")} €</span> : <span className="f3 fw7">---</span>}</td>
                        </tr>*/}
                      </tbody>
                    </table>
                    </div>
                  <ProductPrice className={"f2 pb4 pt0 relative lh-solid"} product={product}/>
                  {(product && product.canBeBought) && <div>
                    {shop.session &&
                      <div className="product-actions">
                        {product &&
                          <Input type="number" min={0} placeholder="1" defaultValue={product.count} value={this.state.count} action onChange={e => {
                            if(e.target.value == ""){
                              this.setState({ count: 1 });
                            }
                            this.setState( { count: e.target.value } )
                          }
                          }>
                            <input/>
                            {/*<Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[ 0 ].map_desc_id}
                                    onChange={( e, data ) => {
                                      const { value } = data
                                      const ve = product.quantities.filter( q => q.map_desc_id === value )
                                      if ( !ve ) return
                                      product.unit_multi = ve[ 0 ].multi
                                      product.unit_id = ve[ 0 ].map_desc_id
                                      console.log( { data, e, value: e.target.value, target: e.target } )
                                    }
                                    }
                            /> */} <span className=" tc pt2 pl2 fw6 f3">{translate("VE")} </span>

                          </Input>
                        }
                        <div className="pt1 flex flex-row justify-between">
                          <Button primary disabled={product.extras.stockColor.value.value == "red"} onClick={() => {
                            if (this.state.count > 100) {
                              this.setState({ count: 100 });
                              shop.toast("Maximale Abnahmemenge angepasst, 100 VE in den Warenkorb gelegt.", "info", false, "bottom");
                              product.count = 100;
                              setTimeout(() => {
                                product.count = 100;
                                this.setState({ count: 100 });
                              }, 100);
                            }
                            else{
                              product.count = this.state.count || 1
                            }
                            console.info( "BUY", this.state.count, product.unit_multi, product.unit_id )
                            this.add( { product } )
                          }
                          }>
                            <div className="ph3 ph4-ns flex flex-row items-center justify-center">
                              <Icon name={"shopping cart"}/>
                            </div>
                          </Button>
                          <ButtonLove list={shop.orderlist.default} 
                                      circular={false}
                                      className="dib mr3"
                                      elementInActive={<div className={"ph3 pv2"}><Icon name={"heart"}/> {translate( "Merkliste" )}</div>}
                                      elementActive={<div className={"ph3 pv2"}><Icon name={"heart"} className={"red"}/> {translate( "Merkliste" )}</div>}
                                      product={product}/>
                        </div>
                      </div>}

                  </div>}
                </div>}

                <DescriptionSection product={product}/>
                {shop.session && <BulkPricing product={product}/>}
                {!shop.session && <div>
                  <p>
                    {translate( "shop.please_login_for_product_details" )}
                  </p>

                  <div className="mw6">
                    <div className="pb2">
                      <Link to={`/login?referrer=${location.pathname}`}><Button fluid> {translate( "shop.login" )}</Button></Link>
                    </div>
                    <Link to="/customer_registration"><Button fluid> {translate( "shop.register" )}</Button></Link>
                  </div>
                </div>}
                {/*{shop.session && <ProductTechnicalTable product={product} />}*/}


                <ProductReplacementHints key={product.map_id} product={product}/>

                <div className="pt3 pt4-ns">
                  <h3>{translate( "Verfügbarkeit" )}</h3>
                  <div>
                    {product.getNotice()}
                  </div>
                </div>
                <section>
                  
                  <Variants byAttribute={byAttribute} product={product}/>
                  {/*{variants && variants.products && variants.products.map( variant => <ProductVariant key={variant.map_id} product={variant}/> )}*/}
                  {/*<pre>{JSON.stringify( variants && variants.variants.varfields, null, 2 )}</pre>*/}
                </section>
                <br/>
                <br/>

                <div className="">

                  <Collapsible tabIndex={0} open={true}
                               triggerClassName="cssOptima f3 fw7"
                               triggerOpenedClassName="cssOptima f3 fw7"
                               trigger={translate( "Produktinformationen" )}>
                    <CustomDisplay product={product} productInfos={1}/>
                  </Collapsible>
                  <Collapsible tabIndex={0} open={false}
                               triggerClassName="cssOptima f3 fw7"
                               triggerOpenedClassName="cssOptima f3 fw7"
                               trigger={translate( "Nährwertangaben je 100g:" )}>
                    <CustomDisplay product={product} productInfos={2}/>
                  </Collapsible>
                  <Collapsible tabIndex={0} open={false}
                               triggerClassName="cssOptima f3 fw7"
                               triggerOpenedClassName="cssOptima f3 fw7"
                               trigger={translate( "Zutaten & Allergene:" )}>
                    <CustomDisplay product={product} productInfos={3}/>
                  </Collapsible>
                </div>
                {shop.session && <div className="pt3 pt4-ns">
                  <ProductDownloads product={product}/>
                </div>}

                <br/>
                <br/>
              </Col>
            </Row>
          </section>
          {/*	*/}
        </Container>

        {product.extras.Kollektion && <div className="bg-silver pv4">
          <Container>
            <section className=" pt3 pb5">

              <div className="cf relative pb3">
                {product.category.desc &&
                  <Link to={`/collection-extra/Kollektion/${product.extras.Kollektion}`}><h2
                    className="mt2 ttu">{`${translate( "Topseller aus Kollektion" )}  ${product.extras.Kollektion}`} <Icon
                    name="chevron right"/></h2>
                  </Link>}
              </div>

              <ProductSearchExtra
                count={4}
                start={0}
                extra={"Kollektion"}
                extraValue={product.extras.Kollektion}
                query="%%"
                repeat={ProductCard}/>
            </section>

          </Container>
        </div>}

        {product.category && <div className="pv4">
          <Container>
            <section className="section-product-slider">
              <div className="cf relative pb3">
                {product.category.desc && <Button basic as={Link} to={`/collection/${product.category.getParents().join( "/" )}/${product.category.map_desc_id}/`}><h2
                  className="mt2 ttu">{`${translate( "Topseller aus" )} ${product.category.desc.des ||
                product.category.desc.short_des}`} <Icon name="chevron right"/></h2>
                </Button>}
              </div>

              <ProductSearch
                count={4}
                start={0}
                cats={[cat_id]}
                query="%%"
                repeat={ProductCard}/>
            </section>
          </Container>
        </div>}

        <div className="pv4 bg-silver">
          <Container>
            {/*Product Slider "last viewed"*/}
            <section className="section-product-slider pv5">
              {console.log("lastProducts", lastProducts)}
              <h2 className="mt2  ttu">{translate( "Zuletzt angesehen" )}</h2>
              <ProductList
                count={4}
                start={0}
                displayMode={"grid"}
                list={lastProducts}
                repeat={ProductCard}/>
            </section>
          </Container>
        </div>
      </div>
    )
  }
}

ProductPage.propTypes = {
  price: PropTypes.any
}

const CustomDisplay = ( { product, productInfos } ) => {
  let primaryCategory = product.category
  let cid = primaryCategory && primaryCategory.cat_id || String( product.category && product.category.map_id )
  let configByCategory = cmsStore.config.orthoFieldProductDetailConfigByCategory[ cid ] || cmsStore.config.orthoFieldProductDetailConfigByCategory[ "DEFAULT_EXTENDED" ] || {}

  const [translations, setTranslations] = React.useState( false )
  React.useEffect( () => {
    if ( !configByCategory || !configByCategory.columns ) {
      return setTranslations( true )
    }
    let promises = configByCategory.columns && configByCategory.columns
                                                               .filter( e => e )
                                                               .map( columnKey => {
                                                                 categoryStore.loadTranslatedFields( { fieldName: columnKey } )
                                                               } )

    let translations = Promise.all( promises )
                              .then( res => {
                                setTranslations( true )
                              } )

  }, [product] )

  if ( !translations ) return <div>
    LOADING
  </div>
  return (
    <div>
      {productInfos == 1 &&
      <Fragment><table basic={"very"}>
        <Table.Body>

          {/*<Table.Row positive >*/}
          {/*	<Table.Cell>product.desc.des</Table.Cell>*/}
          {/*	<Table.Cell><b>{product.desc.des}</b></Table.Cell>*/}
          {/*</Table.Row>*/}

          {/*<Table.Row positive>*/}
          {/*	<Table.Cell>product.desc.short_des</Table.Cell>*/}
          {/*	<Table.Cell><b>{product.desc.short_des}</b></Table.Cell>*/}
          {/*</Table.Row>*/}


          {/*<Table.Row>*/}
          {/*	<Table.Cell>VE</Table.Cell>*/}
          {/*	<Table.Cell><b><span>{product.unit_multi} Stück</span></b></Table.Cell>*/}
          {/*</Table.Row>*/}

          <tr  className="bb b--black-20  f5">
            <td>
              <label className={" "}>
                {translate( "Lindt Art.Nr." )}
              </label>
            </td>
            <td className="fr fw5">
              {product.article_nr}
            </td>
          </tr>


          {/*<Table.Row>*/}
          {/*	<Table.Cell>Verfügbar</Table.Cell>*/}
          {/*	<Table.Cell><b><span>{product.stock} Stück</span></b></Table.Cell>*/}
          {/*</Table.Row>*/}

        {product.extras && Object.keys( product.extras ).sort()
                                      .filter( e => e )
                                      .filter(e => ![
                                        "zutaten", "detail", "preisEK", "preisUVP", "veInhalt", "stockText", "stockColor", "verfuegbar",
                                      ].some(prefix => e.startsWith(prefix)))
                                      .sort((a, b) => {
                                        const aSort = (product.extras[a] && product.extras[a].sort) || 9999;
                                        const bSort = (product.extras[b] && product.extras[b].sort) || 9999;
                                        if (aSort === bSort) return a.localeCompare(b);
                                        return aSort - bSort;
                                      })
                                      .map( columnKey => {
                                        const valueObject = product.extras[ columnKey ]
                                        if ( !valueObject ) return null
            if ( !valueObject.value ) return null
            const value = (valueObject.value.text.startsWith(",") || (valueObject.value.text.split(",").length >= 3)) ? valueObject.value.text.replaceAll(",", ", ") : valueObject.value.text;
            return <React.Fragment key={columnKey}>
              <tr className="bb b--black-20  f5">
              <td className="pa3">{valueObject.text || translate( columnKey )}</td>
              {<td className="fr pa3 fw5">{value || "Kein Wert"}</td>}
              </tr>
            </React.Fragment>
                                      } )}
        </Table.Body>
      </table>
      </Fragment>}
            {productInfos == 2 &&
      <Fragment><table basic={"very"}>
        <Table.Body>
{product.extras &&
  Object.keys(product.extras)
    .filter(e => e) // kein leerer Key
    .filter(e => ![
      "Zubehör", "eanKE", "eanVE", "preisEK", "preisUVP", "veInhalt",
      "zutaten", "stockText", "stockColor", "pluralVE", "Preisanfrage", 
      "Stock", "mengenMulti","format", "mwst", "rezeptur", "schokotyp", "verfuegbar", "sortiment"
    ].some(prefix => e.startsWith(prefix)))
    .sort((a, b) => {
          const aSort = (product.extras[a] && product.extras[a].sort) || 9999;
          const bSort = (product.extras[b] && product.extras[b].sort) || 9999;
      if (aSort === bSort) return a.localeCompare(b);
      return aSort - bSort;
    })
    .map(columnKey => {
      const valueObject = product.extras[columnKey];
      if (!valueObject || !valueObject.value) return null;

      const rawText = valueObject.value.text;
      const value =
        rawText.startsWith(",") || rawText.split(",").length >= 3
          ? rawText.replaceAll(",", ", ")
          : rawText;

      return (
        <React.Fragment key={columnKey}>
          <tr className="bb b--black-20 f5">
            <td className="pa3">{valueObject.text || translate(columnKey)}</td>
            <td className="fr pa3 fw5">{value || "Kein Wert"}</td>
          </tr>
        </React.Fragment>
      );
    })}
        </Table.Body>
      </table>
      </Fragment>}
            {productInfos == 3 &&
      <Fragment><table basic={"very"}>
        <Table.Body>
            {product.extras && Object.keys(product.extras).sort()
              .filter(e => e && e.toLowerCase() === "zutaten")
              .map(columnKey => {
                const valueObject = product.extras[columnKey]
                if (!valueObject) return null
                if (!valueObject.value) return null
                const value = (valueObject.value.text.startsWith(",") || (valueObject.value.text.split(",").length >= 3)) ? valueObject.value.text.replaceAll(",", ", ") : valueObject.value.text;
                return (
                  <React.Fragment key={columnKey}>
                    <tr className="f5">
                      <td className="pa3 fw5">{value || "Kein Wert"}</td>
                    </tr>
                  </React.Fragment>
                )
              })}
        </Table.Body>
      </table>
      </Fragment>}
    </div>
  )
}

const ProductVariant = ( { product } ) => {
  return (
    <Card as={Link} to={`/product/${product.map_id}`}>
      <img className="ui image" src={product.img_src_medium}/>
      <div>{product.extras.Art}</div>
      <div>{product.extras.Groesse}</div>
    </Card>
  )
}

const BulkPricing = ( { product } ) => {
  if ( !product.prices || product.prices.length === 1 ) return null
  return (

    <div>
      <h4>{translate( "Staffelpreise" )} </h4>
      <Table>
        <tbody>
        {product.prices.map( price => (
          <tr key={price.q}>
            <td>{translate( "ab" )} {price.q} {translate( "KE" )}</td>
            <td><Price>{price.p}</Price></td>
          </tr>
        ) )}
        </tbody>
      </Table>

    </div>
  )
}

const Fullscreen = ( { image, change, images } ) => {
  document.body.classList.remove( "no-scroll" )
  if ( !image ) {
    return null
  }
  window.scrollTo && window.scrollTo( 0, 0 )
  const imgs = _.map( images, ( { img_src_large, img_src_small }, key ) => {
    return (
      <img key={key}
           onClick={() => {
             change( img_src_large )
           }}
           className="img-thumbnail "
           src={img_src_small}/>
    )
  } )

  document.body.classList.add( "no-scroll" )
  return (
    <div className="fullscreen">
      <div className="ui pull-right"
           style={{ position: "relative" }}>
        <Button icon="close"
                basic
                onClick={() => {
                  change( false )
                }}/>
      </div>

      <div className="center-child "
           onClick={() => {
             change( false )
           }}>
        <div className="zoom-out img-container">
          <img src={image} alt=""/>
        </div>
      </div>

      <div className="ui ui-bottom pull-right ">
        <div className="product-images">
          {imgs}
        </div>
      </div>
    </div>
  )
}

Fullscreen.propTypes = {
  children: PropTypes.object, change: PropTypes.func, images: PropTypes.array
}

const AdditionalTable = ( { product } ) => {
  return (
    <section className="AdditionalTable">
      <Row>
        <Col sm="1" md="1" className="pb3">
          <div className="technischetabelle">
            <strong>weitere Details</strong>
            <table className="table-technical">
              <tbody>
              {product && shop.session.group !== "WERBE" ? <tr>
                <td>UVP inkl. MwSt.</td>
                <td className="text-right"><Price className="fw1">{product.extras.evkpre}</Price></td>
              </tr> : null}
              {product && shop.session.group === "WERBE" ? <tr>
                <td>Industriepreis Netto</td>
                <td className="text-right"><Price className="fw1">{product.extras.indpre}</Price></td>
              </tr> : null}
              {product ? <tr>
                <td>EAN</td>
                <td className="text-right">{product.barcode}</td>
              </tr> : null}
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </section>
  )
}

AdditionalTable.propTypes = {
  product: PropTypes.object
}

const TitleSection = ( { product } ) => (
  <section className="product-title mb0 pb0 ">
    <div className="brand">{product.extras.herst !== "unbekannt" &&
      <Link to={`/brand/${product.extras.herst}`}>{product.extras.herst}</Link>}</div>
    <div className="cssOptima  title f3 f2-ns b lh-copy">{product.desc.short_des}</div>

    {/*<div className="title f1 b lh-copy">{product.desc.des}</div>*/}
    <div className="id pt2 pb2 pv2"> {translate("Lindt Art.Nr.")} {product.article_nr || product.article_id}</div>

    {product.extras.statusinfo && <Message>{product.extras.statusinfo}</Message>}
    {product.extras.isnew && <Label color={"blue"}>{translate( "Achtung Neuheit - nur vorbestellbar" )}</Label>}


    {/* Availability*/}
    {/*{shop.config.useAvailability !== false && <Availability product={product} />}*/}
    {/*<Availability product={product}/>*/}

  </section>
)

TitleSection.propTypes = {
  product: PropTypes.object
}

const Availability = ( { product } ) => {
  let notice = product.getNotice()
  return (
    <div className="availability">
      {notice}
    </div>
  )
}

const ActionSection = ( { product, onChange, onAdd } ) => {
  if ( !product.canBeBought ) return null
  const list = shop.orderlist.default
  return (
    <section className="product-actions pt2 pb4">
      <div style={{ display: "inline-block " }}>
        <p>
          {product.count * product.unit_multi} Stück <Price
          className="f5 fw2 black-50">{product.count * product.unit_multi * product.price}</Price></p>

        <ProductQuantityGroup product={product}
                              list={list}
                              showVE={false}
                              onChange={onChange}
                              onAdd={onAdd}
                              large/>
      </div>
    </section>
  )
}

ActionSection.propTypes = {
  product: PropTypes.object,
  onChange: PropTypes.func,
  onAdd: PropTypes.func,
}

const DescriptionSection = ( { product } ) => (
  <section className="description pv3 lh-copy">
    {product.desc.des}
  </section>
)
DescriptionSection.propTypes = {
  product: PropTypes.object,
}


ProductImages.propTypes = {
  images: PropTypes.any,
  image: PropTypes.any,
  onClick: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/theme/lindtbShop/pages/ProductPage.js